import { useEffect, useState } from 'react';
import PhotoAPIHelpers from './PhotoAPIHelpers';
import { Buffer } from 'buffer';
import { Preloader } from '../../../shared/Preloader/Preloader';

export type ObservationsFormType = 'edit' | 'create';

interface IPhotoProps {
  observationId: number;
  url: string;
  height?: string;
}

export const Photo = ({ observationId, url, height }: IPhotoProps) => {
  const [src, setSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const loadImage = async () => {
      const split = url.split('/');
      const image = await PhotoAPIHelpers.getImage(
        observationId,
        split[split.length - 1]
      );
      setSrc(Buffer.from(image).toString('base64'));
      setIsLoading(false);
    };
    loadImage();
  }, [observationId, url]);

  return (
    <>
      {isLoading ? (
        <Preloader height={'600px'}></Preloader>
      ) : (
        <img
          src={`data:image/jpg;base64,${src}`}
          alt="observation"
          height={height || '100px'}
          width="100%"
          style={{ objectFit: 'cover' }}
        />
      )}
    </>
  );
};
